
import { AmmunitionStockEventTypeInfoBase } from './ammunition-stock-event.typeinfo.base';


export class AmmunitionStockEventTypeInfo extends AmmunitionStockEventTypeInfoBase {

  historyRouteBase = ['/ammunitionstockevent/history'];
  rangerHistoryRouteBase = ['/ammunitionstockevent/rangerhistory/'];

}

export const AMMUNITION_STOCK_EVENT_TYPE: AmmunitionStockEventTypeInfo = new AmmunitionStockEventTypeInfo();



